export const REQUESTED_MORNINGSTAR_ASSOCIATION =
  'REQUESTED_MORNINGSTAR_ASSOCIATION';
export const RECEIVED_MORNINGSTAR_ASSOCIATION =
  'RECEIVED_MORNINGSTAR_ASSOCIATION';
export const ERROR_MORNINGSTAR_ASSOCIATION = 'ERROR_MORNINGSTAR_ASSOCIATION';

export const REQUESTED_MORNINGSTAR_ASSOCIATION_URL =
  'REQUESTED_MORNINGSTAR_ASSOCIATION_URL';
export const RECEIVED_MORNINGSTAR_ASSOCIATION_URL =
  'RECEIVED_MORNINGSTAR_ASSOCIATION_URL';
export const ERROR_MORNINGSTAR_ASSOCIATION_URL =
  'ERROR_MORNINGSTAR_ASSOCIATION_URL';

export const REQUESTED_MORNINGSTAR_CONSENT = 'REQUESTED_MORNINGSTAR_CONSENT';
export const RECEIVED_MORNINGSTAR_CONSENT = 'RECEIVED_MORNINGSTAR_CONSENT';
export const ERROR_MORNINGSTAR_CONSENT = 'ERROR_MORNINGSTAR_CONSENT';

export const REQUESTED_MORNINGSTAR_REGISTRATION_CALLBACK =
  'REQUESTED_MORNINGSTAR_REGISTRATION_CALLBACK';
export const RECEIVED_MORNINGSTAR_REGISTRATION_CALLBACK =
  'RECEIVED_MORNINGSTAR_REGISTRATION_CALLBACK';
export const ERROR_MORNINGSTAR_REGISTRATION_CALLBACK =
  'ERROR_MORNINGSTAR_REGISTRATION_CALLBACK';

export const errorMorningstarAssociation = (error) => ({
  type: ERROR_MORNINGSTAR_ASSOCIATION,
  error
});

export const receivedMorningstarAssociation = (response) => ({
  type: RECEIVED_MORNINGSTAR_ASSOCIATION,
  payload: {
    ...response
  }
});

export const requestedMorningstarAssociation = () => ({
  type: REQUESTED_MORNINGSTAR_ASSOCIATION
});

export const errorMorningstarAssociationUrl = (error) => ({
  type: ERROR_MORNINGSTAR_ASSOCIATION_URL,
  error
});

export const receivedMorningstarAssociationUrl = (response) => ({
  type: RECEIVED_MORNINGSTAR_ASSOCIATION_URL,
  payload: {
    ...response
  }
});

export const requestedMorningstarAssociationUrl = () => ({
  type: REQUESTED_MORNINGSTAR_ASSOCIATION_URL
});

export const receivedMorningstarConsent = (response) => ({
  type: RECEIVED_MORNINGSTAR_CONSENT,
  response
});

export const errorMorningstarConsent = (error) => ({
  type: ERROR_MORNINGSTAR_CONSENT,
  error
});

export const requestedMorningstarConsent = () => ({
  type: REQUESTED_MORNINGSTAR_CONSENT
});

export const errorMorningstarRegistrationCallback = (error) => ({
  type: ERROR_MORNINGSTAR_REGISTRATION_CALLBACK,
  error
});

export const receivedMorningstarRegistrationCallback = (response) => ({
  type: RECEIVED_MORNINGSTAR_REGISTRATION_CALLBACK,
  payload: {
    ...response
  }
});

export const requestedMorningstarRegistrationCallback = () => ({
  type: REQUESTED_MORNINGSTAR_REGISTRATION_CALLBACK
});
